import merge from 'lodash/merge'
import chatColors from './chat-colors'

export function parseJsonObject (value) {
  if (!value) return {}
  if (typeof value === 'object' && !Array.isArray(value)) return value
  if (typeof value !== 'string') return {}

  try {
    const parsed = JSON.parse(value)
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed
    return {}
  } catch {
    return {}
  }
}

export function resolveNamedTheme (themeName) {
  return chatColors[themeName] || chatColors.blue
}

export function mergeTheme ({ themeName, serverTheme, themeOverride } = {}) {
  return merge(
    {},
    resolveNamedTheme(themeName),
    parseJsonObject(serverTheme),
    parseJsonObject(themeOverride)
  )
}

export function resolveServerLang (serverLang) {
  const lang = parseJsonObject(serverLang)
  if (lang.default && typeof lang.default === 'object') return lang.default
  return lang
}

export function mergeLangMessages (currentMessages, serverLang, langOverride) {
  return merge(
    {},
    currentMessages || {},
    resolveServerLang(serverLang),
    parseJsonObject(langOverride)
  )
}
